function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d6)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "icon_focused",
  x: 6.5,
  y: 4.5,
  width: 29,
  height: 29,
  fill: "#8AC341",
  stroke: "#8AC341",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "10 10"
}), /*#__PURE__*/React.createElement("rect", {
  className: "icon_selected_fill",
  x: 9,
  y: 7,
  width: 24,
  height: 24,
  fill: "white",
  stroke: "#373A3C",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 21.6024L17.8125 21.3289C17.9818 22.2729 18.3236 22.9663 18.8379 23.409C19.3587 23.8517 20.0586 24.0731 20.9375 24.0731C21.8685 24.0731 22.5684 23.8777 23.0371 23.4871C23.5124 23.09 23.75 22.6277 23.75 22.1004C23.75 21.7619 23.6491 21.4754 23.4473 21.241C23.252 21.0001 22.9069 20.7918 22.4121 20.616C22.0736 20.4988 21.3021 20.2905 20.0977 19.991C18.5482 19.6069 17.4609 19.1349 16.8359 18.575C15.957 17.7873 15.5176 16.827 15.5176 15.6942C15.5176 14.965 15.7227 14.2846 16.1328 13.6531C16.5495 13.0151 17.1452 12.5301 17.9199 12.1981C18.7012 11.866 19.6419 11.7 20.7422 11.7C22.5391 11.7 23.89 12.0939 24.7949 12.8817C25.7064 13.6694 26.1849 14.7208 26.2305 16.0359L23.3398 16.1629C23.2161 15.4272 22.9492 14.8999 22.5391 14.5809C22.1354 14.2554 21.5267 14.0926 20.7129 14.0926C19.873 14.0926 19.2155 14.2651 18.7402 14.6102C18.4342 14.8315 18.2812 15.1277 18.2812 15.4988C18.2812 15.8374 18.4245 16.1271 18.7109 16.368C19.0755 16.674 19.9609 16.993 21.3672 17.325C22.7734 17.657 23.8118 18.0021 24.4824 18.3602C25.1595 18.7117 25.6868 19.1968 26.0645 19.8152C26.4486 20.4272 26.6406 21.1857 26.6406 22.0906C26.6406 22.9109 26.4128 23.6792 25.957 24.3953C25.5013 25.1115 24.8568 25.6453 24.0234 25.9969C23.1901 26.3419 22.1517 26.5145 20.9082 26.5145C19.0983 26.5145 17.7083 26.0978 16.7383 25.2645C15.7682 24.4246 15.1888 23.2039 15 21.6024Z",
  fill: "#373A3C"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d6",
  x: 0,
  y: 0,
  width: 42,
  height: 42,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgStockIcon = function SvgStockIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    className: "svgIcon",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStockIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stock-icon.f6f1c219.svg";
export { ForwardRef as ReactComponent };